import { ActionTree, GetterTree, MutationTree } from "vuex";
import { RootState, StateTags } from "@/store/types";
import { ACTION_TYPES, MUTATION_TYPES } from "@/lib/const";
import providers from "@/lib/providers";
import { InputTagInfo, TagInfo } from "@teacherskaya/api-provider/dist/api/TagsProvider";

const { STORE_DATA } = MUTATION_TYPES;
const { SET_DATA, GET_DATA, ADD_DATA, DEL_DATA } = ACTION_TYPES;

export const state = (): StateTags => {
  return {
    tags: [],
  };
};

export const getters: GetterTree<StateTags, RootState> = {
  countSlug: () => (title: string) => title.replace(/[^A-Za-z0-9_]/g, "_").toLocaleLowerCase(),
};

export const mutations: MutationTree<StateTags> = {
  [STORE_DATA]: (state, payload) => {
    state.tags = payload.tags;
  },
};

export const actions: ActionTree<StateTags, RootState> = {
  async [GET_DATA](context) {
    // @ts-ignore
    return providers.TagsProvider.findAll().then(tags => {
      context.commit(STORE_DATA, { tags });
      return tags;
    });
  },
  async [ADD_DATA](context, payload: string) {
    const data: InputTagInfo = {
      title: payload,
      slug: context.getters.countSlug(payload),
    };
    // @ts-ignore
    return providers.TagsProvider.create({ data }).then(tag => {
      const tags = [...context.state.tags, tag];
      context.commit(STORE_DATA, { tags });
      return tag;
    });
  },
  async [SET_DATA](context, { id, title }: TagInfo) {
    const data: InputTagInfo = {
      title,
      slug: context.getters.countSlug(title),
    };
    // @ts-ignore
    return providers.TagsProvider.update({ id, data }).then(tag => {
      const tags = [...context.state.tags].map(item => {
        if (item.id === tag.id) {
          item = tag;
        }
        return item;
      });
      context.commit(STORE_DATA, { tags });
      return tag;
    });
  },
  async [DEL_DATA](context, id: string) {
    // @ts-ignore
    return providers.TagsProvider.delete({ id }).then(r => {
      if (r) {
        const tags = [...context.state.tags].filter(item => item.id !== id);
        context.commit(STORE_DATA, { tags });
      }
      return r;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
